// extracted by mini-css-extract-plugin
export var center = "_4p-2";
export var clickableRow = "_4p-5";
export var expandedRow = "_4p-7";
export var hoverable = "_4p-4";
export var left = "_4p-1";
export var right = "_4p-3";
export var row = "_4p-0";
export var selectedRow = "_4p-6";
export var summaryRow = "_4p-8";